<script>
	import { onDestroy, getContext } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../library/scripts/styles'
	import { storeData } from '../library/scripts/Store.svelte'
	import { validate } from '../library/scripts/validate.js'
	import { admin } from '../library/scripts/PhpHandler.svelte'

	const globals = getContext('globals')

	const colorError = globals.colorError
	const fontSmall = globals.fsS

	let email
	let infoLeftPadding
	let contactBlock
	let infoAddressColor
	let infoAddressFontSize
	let infoAddressFontFamily
	let infoAddressWeight
	let infoAddressStyle
	let inputFontColor
	let inputFontFamily
	let inputFontSize
	let inputBorder
	let inputBg
	let inputFocus
	let inputShadowX
	let inputShadowY
	let inputShadowBlur
	let inputShadowColor
	let buttonBg
	let buttonHover
	let buttonFontHover
	let buttonFontColor
	let buttonFontFamily
	let buttonFontSize
	let buttonBorderWidth
	let buttonBorderColor
	let buttonBorderRadius
	let buttonText

	let errorMail = false
	let errorMessage

	//open/ close the register tab
	let showRegister = false

	//mail successful registered
	let success = false

	//timeouts
	let toError

	let configFile
	const stoData = storeData.subscribe((value) => {
		if (value) {
			configFile = value

			value.blocks.forEach((block) => {
				if (block.blockName === 'contact') {
					contactBlock = block
					infoLeftPadding = contactBlock.infoLeftPadding + '%'
					infoAddressColor = contactBlock.infoAddressColor
					infoAddressFontSize = contactBlock.infoAddressFontSize
					infoAddressFontFamily = contactBlock.infoAddressFontFamily
					infoAddressWeight = contactBlock.infoAddressWeight
					infoAddressStyle = contactBlock.infoAddressStyle
					inputFontColor = contactBlock.inputFontColor
					inputFontFamily = contactBlock.inputFontFamily
					inputFontSize = contactBlock.inputFontSize
					inputBorder = contactBlock.inputBorder
					inputBg = contactBlock.inputBg
					inputFocus = contactBlock.inputFocus
					inputShadowX = contactBlock.inputShadowX + 'px'
					inputShadowY = contactBlock.inputShadowY + 'px'
					inputShadowBlur = contactBlock.inputShadowBlur + 'px'
					inputShadowColor = contactBlock.inputShadowColor
					buttonBg = contactBlock.buttonBg
					buttonHover = contactBlock.buttonHover
					buttonFontHover = contactBlock.buttonFontHover
					buttonFontColor = contactBlock.buttonFontColor
					buttonFontFamily = contactBlock.buttonFontFamily
					buttonFontSize = contactBlock.buttonFontSize
					buttonBorderWidth = contactBlock.buttonBorderWidth + 'px'
					buttonBorderColor = contactBlock.buttonBorderColor
					buttonBorderRadius = contactBlock.buttonBorderRadius + 'px'
					buttonText = contactBlock.buttonText
				}
			})
		}
	})

	const send_register = async () => {
		if (!validate('email', email)) {
			errorMail = true
			errorMessage = 'enter a valid email-address '
			toError = setTimeout(() => {
				errorMail = false
				errorMessage = null
			}, 2000)
			return
		}

		const response = await admin({ cmd: 'registermail', mail: email })

		if (response.response === 'mail exists already') {
			errorMail = true
			errorMessage = 'email already registered '
			toError = setTimeout(() => {
				errorMail = false
				errorMessage = null
			}, 2000)
			return
		}

		errorMessage = 'Vielen Dank. Email hinzugefügt.'
		success = true
		toError = setTimeout(() => {
			errorMail = false
			errorMessage = null
			success = false
			email = null
			showRegister = false
		}, 2000)
	}

	const show_register = () => {
		showRegister = showRegister === true ? false : true
	}

	onDestroy(() => {
		stoData
		clearTimeout(toError)
	})
</script>

{#if configFile}
	<div class="list_outer" use:styles={{ infoLeftPadding }}>
		<div
			class="list_title"
			on:click={show_register}
			on:keydown={show_register}
			use:styles={{
				infoAddressColor,
				infoAddressFontFamily,
				infoAddressFontSize,
				infoAddressWeight,
				infoAddressStyle,
			}}
		>
			Newsletter bestellen
		</div>
		{#if showRegister}
			<div transition:slide={{ duration: 2000 }}>
				{#if !errorMail && !success}
					<input
						type="text"
						bind:value={email}
						placeholder="name"
						use:styles={{
							inputFontColor,
							inputFontFamily,
							inputFontSize,
							inputBorder,
							inputBg,
							inputShadowX,
							inputShadowY,
							inputShadowBlur,
							inputShadowColor,
							inputFocus,
						}}
					/>
					<div class="button_container">
						<button
							on:click={send_register}
							use:styles={{
								buttonBg,
								buttonHover,
								buttonFontHover,
								buttonFontColor,
								buttonFontFamily,
								buttonFontSize,
								buttonBorderWidth,
								buttonBorderColor,
								buttonBorderRadius,
								buttonText,
							}}
						>
							anmelden
						</button>
					</div>
				{:else if success}
					<span class="success" use:styles={{ fontSmall }}>{errorMessage}</span>
				{:else}
					<span class="error" use:styles={{ colorError, fontSmall }}>{errorMessage}</span>
				{/if}
			</div>
		{/if}
	</div>
{/if}

<style>
	button {
		background-color: var(--buttonBg);
		color: var(--buttonFontColor);
		font-family: var(--buttonFontFamily);
		font-size: var(--buttonFontSize);
		border: var(--buttonBorderWidth) solid var(--buttonBorderColor);
		border-radius: var(--buttonBorderRadius);
		box-shadow: var(--inputShadowX) var(--inputShadowY) var(--inputShadowBlur) var(--inputShadowColor);
		width: fit-content;
		height: fit-content;
		cursor: pointer;
	}

	input {
		outline: none;
		width: 90%;
		color: var(--inputFontColor);
		font-family: var(--inputFontFamily);
		font-size: var(--inputFontSize);
		border: 1px solid var(--inputBorder);
		background-color: var(--inputBg);
		box-shadow: var(--inputShadowX) var(--inputShadowY) var(--inputShadowBlur) var(--inputShadowColor);
	}

	input:focus {
		background-color: var(--inputFocus);
	}
	.list_outer {
		margin-top: 4%;
		padding-left: var(--infoLeftPadding);
		display: flex;
		flex-direction: column;
	}

	.list_title {
		color: var(--infoAddressColor);
		font-size: var(--infoAddressFontSize);
		font-family: var(--infoAddressFontFamily);
		font-weight: var(--infoAddressWeight);
		font-style: var(--infoAddressStyle);
		margin-bottom: 10px;
		cursor: pointer;
	}

	.button_container {
		display: flex;
		width: 90%;
		justify-content: flex-end;
	}

	.error {
		font-size: var(--fontSmall);
		color: var(--colorError);
	}

	.success {
		font-size: var(--fontSmall);
		color: forestgreen;
	}
</style>
